import React, { Component } from "react";
import { SettingOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import Table from '@/components/EditableTable';
import ChannelCompSelect from './channelCompSelect';
import { TX, RX } from "../../../services/Andes_v2/preLayout";
import { updateChannelsBySignalAndComp, getChannels } from '../../../services/Andes_v2/seaSim';
import { SERDES_TYPES } from "../../../services/PCBHelper";
import { strDelimited } from "../../../services/helper/split";
import DirectionOptions from './DirectionOptions';

const channelsColumns = [
  {
    title: 'Signal',
    dataIndex: 'signal',
    width: '34%',
  },
  /*  {
     title: 'Controller',
     dataIndex: 'controller',
     width: '18%',
   },
   {
     title: 'Device',
     dataIndex: 'device',
     width: '18%',
   }, */
  {
    title: 'Direction',
    dataIndex: 'direction',
    width: '20%',
  },
  {
    title: 'Aggressors',
    dataIndex: 'aggressors',
    width: '54%',
  }
]

class ChannelsTable extends Component {

  constructor(props) {
    super(props);
    this.state = {
      popoverVisible: null,
      directionOptionsVisible: false,
      applyToAll: false,
      applyToGroupSignals: true
    };

    channelsColumns[1].title = (record) => {
      return (
        <div>
          <span>Direction</span>
          <SettingOutlined className="direction-setting-icon" onClick={this.openDirectionOptions} />
        </div>
      );
    }

    channelsColumns[1].onCell = (record) => {
      return {
        edit: "select",
        record,
        options: [TX, RX],
        dataIndex: "direction",
        handleSave: (record) => { this.editDirection(record) }
      }
    }

    channelsColumns[2].render = (text, record) => {
      const aggressors = record.aggressors || [];
      return <span>{aggressors.join(', ')}</span>
    }

    channelsColumns[2].onCell = (record) => {
      return {
        edit: "aurora-select",
        selectMode: 'multiple',
        selectButtonTitle: "Select aggressors",
        record,
        options: this.getAggressorsOptions(record),
        getPopupContainer: document.getElementById("root"),
        dataIndex: "aggressors",
        dropdownMenuClassName: 'aurora-select-dropdown',
        handleSave: (record) => { this.editAggressors(record) },
        onChange: (list, record, setFieldsValue) => this.changeAggressors(list, record, setFieldsValue),
        clearSelected: (value, record, setFieldsValue) => this.clearSelectedAggressors(value, record, setFieldsValue)
      }
    }
  }

  openDirectionOptions = () => {
    this.setState({
      directionOptionsVisible: true
    })
  }

  updateDirectionOptions = (checkedOptions) => {
    this.setState({
      applyToAll: checkedOptions.includes("applyToAll"),
      applyToGroupSignals: checkedOptions.includes("applyToGroupSignals"),
      directionOptionsVisible: false
    })
  }

  getAggressorsOptions = (record) => {
    const { signals, selectedSignals = [] } = this.props;
    return signals.filter(item => selectedSignals.includes(item.name) && item.name !== record.signal).map(item => item.name);
  }

  handleVisibleChange = (visible, type) => {
    this.setState({ popoverVisible: visible ? type : null })
  }

  SelectComponentRender = (type) => {
    const { components, isEndToEnd } = this.props;
    return <ChannelCompSelect
      components={components}
      type={type}
      isEndToEnd={isEndToEnd}
      closePanel={(comp) => this.saveComponent(comp, type)}
    />
  }

  saveComponent = (component, type, anotherType) => {
    this.setState({ popoverVisible: null });
    const { channels, signals, isEndToEnd, components } = this.props;
    let newComp = null;
    if (isEndToEnd) {
      newComp = components.find(item => component === `PCB_${item.pcbIndex} - ${item.name}`);
    } else {
      newComp = components.find(item => item.name === component);
    }

    if (!newComp) {
      return;
    }

    const _channels = updateChannelsBySignalAndComp({ channels, signals, newComp, type, isEndToEnd, components });
    this.props.saveChannels(_channels);

  }

  updateComponent = (record, type) => {
    const component = record[`${type}Comp`];
    if (!component) {
      return;
    }

    const { channels, signals, components, isEndToEnd } = this.props;
    let newComp = null;
    if (isEndToEnd) {
      const [pcb, compName] = strDelimited(component, "::");
      const pcbIndex = strDelimited(pcb, "_", { returnIndex: 1 });
      newComp = components.find(item => item.name === compName && item.pcbIndex === Number(pcbIndex));
    } else {
      newComp = components.find(item => item.name === component);

    }
    if (!newComp) {
      return;
    }
    const _channels = updateChannelsBySignalAndComp({
      channels,
      signals,
      newComp,
      type,
      signal: record.signal,
      isEndToEnd,
      record,
      components
    });
    this.props.saveChannels(_channels);
  }

  editDirection = (record) => {
    const { channels, signals } = this.props;
    const { applyToGroupSignals, applyToAll } = this.state;

    let _channels = [...channels];
    const index = _channels.findIndex(item => item.signal === record.signal);
    if (index < 0) {
      return;
    }
    _channels[index].direction = record.direction;

    if (applyToAll) {
      _channels.forEach(item => {
        item.direction = record.direction
      })
    }

    if (applyToGroupSignals) {
      const signal = signals.find(item => item.name === _channels[index].signal) || {};
      _channels.forEach(item => {
        const findSignal = signals.find(it => it.name === item.signal) || {};
        if (signal.group && signal.group === findSignal.group) {
          item.direction = record.direction;
        }
      })
    }

    this.props.saveChannels(_channels);
  }

  changeAggressors = (list, record, setFieldsValue) => {
    let aggressors = [];
    if (list.length === 1 && record.aggressors.includes(list[0])) {
      aggressors = record.aggressors.filter(item => item !== list[0]);
    } else {
      aggressors = [...new Set([...record.aggressors, ...list])];
    }

    if (setFieldsValue) {
      setFieldsValue({ aggressors });
    }
    this.saveAggressors(aggressors, record.signal);
  }

  clearSelectedAggressors = (value, record, setFieldsValue) => {
    let aggressors = [...record.aggressors];
    aggressors = aggressors.filter(item => item !== value);
    if (setFieldsValue) {
      setFieldsValue({ aggressors });
    }
    this.saveAggressors(aggressors, record.signal);
  }

  editAggressors = (record) => {
    this.saveAggressors(record.aggressors, record.signal);
  }

  saveAggressors = (aggressors, signal) => {
    const { analysisChannels } = this.props;
    let _analysisChannels = [...analysisChannels];
    const index = _analysisChannels.findIndex(item => item.victim === signal);
    if (index < 0) {
      return;
    }

    _analysisChannels[index].aggressors = [...aggressors];
    this.props.saveAnalysisChannels(_analysisChannels);
  }

  render() {
    const { controller, device, dataList } = getChannels(this.props);
    const { maxHeight, isEndToEnd } = this.props;
    const { directionOptionsVisible, applyToGroupSignals, applyToAll } = this.state;
    return (
      <div className="andes-seasim-channels-content">
        {this.getComponents(controller, device)}
        <Table
          rowKey="signal"
          columns={channelsColumns}
          size="small"
          dataSource={dataList}
          scroll={{ y: dataList.length > 8 ? maxHeight : null }}
          className='andes-v2-table channel-config-channels-table space-10'
        />
        {directionOptionsVisible ? <DirectionOptions
          applyToGroupSignals={applyToGroupSignals}
          applyToAll={applyToAll}
          isEndToEnd={isEndToEnd}
          closePanel={this.updateDirectionOptions}
        /> : null}
      </div>
    )
  }

  getICCompsOptions = () => {
    const { components = [], isEndToEnd, selectedSignals } = this.props;
    if (isEndToEnd) {
      return JSON.parse(JSON.stringify(components)).map(item => {
        if (item.isMergeComp || item.isCopyComp) {
          return {
            value: `PCB_${item.pcbIndex} - ${item.name}`,
            label: `PCB_${item.pcbIndex} - ${item.pins.map(it => it.pin).join(', ')} (${item.layer})`
          }
        } else {
          return {
            value: `PCB_${item.pcbIndex} - ${item.name}`,
            label: `PCB_${item.pcbIndex} - ${item.name}`
          }
        }
      });
    } else {
      return components
        .filter(item => SERDES_TYPES.includes(item.type) && (item.pins || []).find(it => selectedSignals.includes(it.signal)))
        .map(item => {
          if (item.isMergeComp || item.isCopyComp) {
            return {
              value: item.name,
              label: `${item.pins.map(it => it.pin).join(', ')} (${item.layer})`
            }
          }

          return {
            value: item.name,
            label: item.name
          };
        })
    }
  }

  getComponents(controller, device) {
    const options = this.getICCompsOptions();
    return <div className="andes-seasim-channels-component-content">
      {[{ label: "Controller", type: "controller", otherType: "device", value: controller },
      { label: "Device", type: "device", otherType: "controller", value: device }].map((item) => {
        return <div className="andes-seasim-channels-component-controller" key={`seasim-${item.type}`}>
          <span>{item.label}</span>
          <Select
            value={item.value}
            showSearch
            onChange={(key) => this.saveComponent(key, item.type, item.otherType)}
            placeholder={item.label}
            className='aurora-select'
            classNames={{ popup: { root: 'aurora-select-dropdown' } }}
            options={options}
          />
        </div>
      })}
    </div>
  }
}


export default ChannelsTable;